import axios from "axios";
import { showErrorToast } from "./toastService.js";

let logoutFunction = () => {
	console.warn("Logout function not set. Please configure it.");
};

let setAccessToken = (token) => {
	console.warn("setAccessToken function not set. Please configure it.", token);
};

let requestOtpFunction = (resolve, reject, originalRequest, session) => {
	console.warn(
		"requestOtpFunction not set. Please configure it.",
		resolve,
		reject,
		originalRequest,
		session
	);
};

export const configureRequestOtp = (f) => {
	requestOtpFunction = f;
};

export const configureLogout = (f) => {
	logoutFunction = f;
};

export const configureSetAccessToken = (f) => {
	setAccessToken = f;
};

const apiClient = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3001",
	timeout: 30000,
});

// Flag per evitare richieste di rinnovo simultanee
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token) => {
	failedQueue.forEach((prom) => {
		if (token) {
			prom.resolve(token);
		} else {
			prom.reject(error);
		}
	});
	failedQueue = [];
};

// Interceptor per richieste
apiClient.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("access-token");
		if (token) {
			config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
		}
		return config;
	},
	(error) => Promise.reject(error)
);

// Interceptor per risposte
apiClient.interceptors.response.use(
	(response) => {
		if (response.data.success === false) {
			showErrorToast(response.data.message);
			return Promise.reject(response);
		}

		// Gestisci il caso di OTP richiesto
		if (response.status === 202 && response.data.optRequired) {
			return new Promise((resolve, reject) => {
				requestOtpFunction(resolve, reject, response.config, response.data.session);
			});
		}

		return response;
	},
	(error) => {
		const originalRequest = error.config;

		if (!error.response) {
			showErrorToast("Network error. Please try again later.");
			return Promise.reject(error);
		}

		const { status } = error.response;

		if ((status === 401 || status === 403) && !originalRequest._retry) {
			originalRequest._retry = true;

			const refreshToken = localStorage.getItem("refresh-token");

			if (!refreshToken) {
				logoutFunction();
				return Promise.reject(error);
			}

			if (isRefreshing) {
				return new Promise((resolve, reject) => {
					failedQueue.push({ resolve, reject });
				})
					.then((token) => {
						originalRequest.headers.Authorization = `Bearer ${token}`;
						return apiClient(originalRequest);
					})
					.catch((err) => Promise.reject(err));
			}

			isRefreshing = true;

			return new Promise((resolve, reject) => {
				axios
					.post(
						`${
							process.env.REACT_APP_API_BASE_URL || "http://localhost:3001"
						}/auth/refresh-token`,
						{ refreshToken }
					)
					.then(({ data }) => {
						localStorage.setItem("access-token", data.accessToken);
						setAccessToken(data.accessToken);

						processQueue(null, data.accessToken);

						originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
						resolve(apiClient(originalRequest));
					})
					.catch((err) => {
						processQueue(err, null);
						logoutFunction();
						reject(err);
					})
					.finally(() => {
						isRefreshing = false;
					});
			});
		}

		showErrorToast(error.response.data.message);

		return Promise.reject(error);
	}
);

const api = {
	get: (url, params = {}, config = {}) => {
		return apiClient.get(url, { params, ...config });
	},
	post: (url, data, config = {}) => {
		return apiClient.post(url, data, config);
	},
	put: (url, data, config) => {
		return apiClient.put(url, data, config);
	},
	delete: (url, config) => {
		return apiClient.delete(url, config);
	},
};

export default api;
